import { IonRouterOutlet, IonHeader, IonToolbar, IonTitle, IonRedirect, IonRouterLink } from '@ionic/react';
import React, { useState, useContext, useEffect } from 'react';

import { Plugins } from '@capacitor/core';

import Home from '../views/Home';

import { Auth_ClientID_context } from '../../../storeState/auth_clientID_context';

const { Storage } = Plugins;


async function removeStorageCredentials() {


    await Storage.remove({ key: 'accountID' });
    await Storage.remove({ key: 'schemaName' });
    await Storage.remove({ key: 'isAuthenticated' });
    await Storage.remove({ key: 'accessRights' });

}

export function ConfirmClientLogout (props){

    let authenticatedClient_context = useContext(Auth_ClientID_context);


    let [acctID, setData_acctID] = useState(authenticatedClient_context.acctID);
    let [baseURL, setBaseURL ] = useState(authenticatedClient_context.baseURL);

    //let [logoutSuccess, setLogoutSuccess] = useState(false);


    useEffect(() => { 

            const requestOptions = {
                method:'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                //body: JSON.stringify({formData})
                body: JSON.stringify({
                    user: acctID,
                })
            }
    
            fetch(baseURL+'userAcct_argsjqApp_logout', requestOptions)
            .then(res => res.text())
            .then(data => {
    
                if(data == '1')
                {
    
                    alert('CLIENT LOG OUT SUCCESSFULL');
    
                    removeStorageCredentials();
                    //setLogoutSuccess(true);

                    //authenticatedClient_context.changeAccountID(null);
                    //authenticatedClient_context.changeSchema(null);
                    authenticatedClient_context.changeAuthenticated(null);
                    //authenticatedClient_context.changeAccessRights('');
        
                }
                else
                {
    
                    alert('LOG OUT - NOT - SUCCESSFULL');
    
                }
    
            })
            .catch(error => {
                console.error(error);
            })

    }, [])


        return(
                <React.Fragment>
                    {/*{ logoutSuccess &&  <Redirect to='/clientLogin' /> }
                    { !logoutSuccess && <Redirect to='/'  /> }*/}

                </React.Fragment>
            )  
}
    

export default ConfirmClientLogout;